import { FETCH_ONBOARDING_APPROVAL_DETAIL } from "../../actions/actionTypes";

const initialState = {  
    onBoardingApprovalDetail: {},
    loading: false,
};

const reducer = (state = initialState, action) => {
    
    switch (action.type) {    
        case FETCH_ONBOARDING_APPROVAL_DETAIL.REQUEST:
            return {...state,onBoardingApprovalDetail: {},loading: true}
        case FETCH_ONBOARDING_APPROVAL_DETAIL.FAILURE:
            return {...state,onBoardingApprovalDetail: {}, loading: false}
        case FETCH_ONBOARDING_APPROVAL_DETAIL.SUCCESS:             
            return {...state, onBoardingApprovalDetail: action.obj.data, loading: false}    
        default:
            return state
    }
}

export default reducer;